import { BlogPostItem } from './../../../../../models/blog.model';
import { Router } from '@angular/router';

import { Component, OnInit, Input } from '@angular/core';
import { DropdownItem } from '../../../dynamic-dropdown/dynamic-dropdown.component';

import { SharedBlogService } from 'src/app/components/user-dashboard/blog/shared-blog.service';

@Component({
  selector: 'app-blog-posts-list-item',
  templateUrl: './blog-posts-list-item.component.html',
  styleUrls: ['./blog-posts-list-item.component.css'],
})
export class BlogPostsListItemComponent implements OnInit {
  @Input() post: BlogPostItem;

  onClickRouter: string | any[];
  dropdownItems: DropdownItem[] = [];

  constructor(
    private router: Router,
    public sharedBlogService: SharedBlogService,
  ) {}

  ngOnInit(): void {
    this.onClickRouter = ['/dashboard', 'blog', this.post.id, 'edit'];

    this.dropdownItems = [
      {
        label: 'Edit Post',
        iconSvg: 'assets/images/svg/system/edit.svg',
        colorSet: 'gray-700',
        colorSetHover: 'primary',
        routerLink: ['/dashboard', 'blog', this.post.id, 'edit'],
      },
      {
        label: 'Preview',
        iconSvg: 'assets/images/svg/system/preview.svg',
        colorSet: 'gray-700',
        colorSetHover: 'primary',
        href: `${this.post.previewUrl}`,
        target: '_blank',
      },
      // {
      //   label: 'Duplicate',
      //   iconSvg: 'assets/images/svg/system/copy.svg',
      //   colorSet: 'gray-700',
      //   colorSetHover: 'primary',
      //   action: () => this.clonePost(this.post),
      // },
      undefined,
      {
        label: 'Delete',
        iconSvg: 'assets/images/svg/system/trash.svg',
        colorSet: 'danger',
        colorSetHover: 'danger',
        action: () => this.deletePost(this.post),
      },
    ];
  }

  goToEdit() {
    this.router.navigate(['/dashboard', 'blog', this.post.id, 'edit']);
  }

  deletePost(item: BlogPostItem) {
    this.sharedBlogService.deleteProductAlert(item);
  }

  clonePost(item: BlogPostItem) {
    // this.sharedBlogService.clonePostAlert(item);
  }
}
